<!-- User Plans Component (Refactored) -->
<!-- Requirements: 7.1, 7.2, 7.3, 7.5, 7.6, 12.1, 12.3 -->

<div class="plans-container">
  <!-- Search and Filters Section (Requirements 7.1, 7.2, 7.3) -->
  <div class="filters-section">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Buscar plano</mat-label>
      <input matInput [(ngModel)]="searchTerm" (ngModelChange)="applyFilters()" placeholder="Digite o nome do plano">
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <mat-button-toggle-group [(ngModel)]="statusFilter" (change)="applyFilters()" aria-label="Filtro de status">
      <mat-button-toggle value="all">Todos</mat-button-toggle>
      <mat-button-toggle value="active">Ativos</mat-button-toggle>
      <mat-button-toggle value="inactive">Inativos</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <!-- Results Count (Requirement 7.5) -->
  <div class="results-info" *ngIf="!isLoading">
    <span>{{ filteredPlans.length }} plano(s) encontrado(s)</span>
  </div>

  <!-- Skeleton Loaders (Requirements 15.1, 15.2) -->
  <div class="plans-grid" *ngIf="isLoading">
    <app-plan-card-skeleton 
      *ngFor="let item of getSkeletonArray(); let i = index"
      [attr.aria-label]="'Carregando plano ' + (i + 1)">
    </app-plan-card-skeleton>
  </div>

  <!-- Plans Grid (Requirement 7.6) -->
  <div class="plans-grid" *ngIf="!isLoading && filteredPlans.length > 0">
    <app-plan-card 
      *ngFor="let plan of filteredPlans"
      [plan]="plan"
      (viewDetails)="openPlanDetails($event)"
      (viewPayments)="navigateToPayments($event)">
    </app-plan-card>
  </div>

  <!-- Empty State (Requirements 12.1, 12.3, 12.4, 12.5) -->
  <div class="empty-state" *ngIf="!isLoading && filteredPlans.length === 0">
    <mat-icon [attr.aria-label]="getEmptyStateIcon() + ' icon'">{{ getEmptyStateIcon() }}</mat-icon>
    <h3>{{ getEmptyStateTitle() }}</h3>
    <p>{{ getEmptyStateMessage() }}</p>
    <button 
      *ngIf="shouldShowEmptyStateAction()"
      mat-raised-button 
      color="primary"
      (click)="handleEmptyStateAction()"
      [attr.aria-label]="getEmptyStateActionLabel()">
      <mat-icon>{{ getEmptyStateActionIcon() }}</mat-icon>
      {{ getEmptyStateActionLabel() }}
    </button>
  </div>
</div>
